import { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LastMinutePackageOption from './LastMinutePackageOption'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'

import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import { sortPackageOptions } from 'lib/offer/offerPageUtil'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const PackageSelectionWrapper = styled(VerticalSpacer)`
  ${mediaQueryUp.tablet} {
    position: relative;
    padding-inline: ${rem(20)};
  }
`

const PackageOptionsGrid = styled(LayoutContainer)`
  padding: 0;
`

interface Props {
  offer: App.HotelOffer
  packageOptions: Array<App.OfferPackageOptionView>
}

function LastMinutePackageOptions(props: Props) {
  const {
    offer,
    packageOptions,
  } = props

  const sortedPackageOptions = useMemo(() => {
    return sortPackageOptions(packageOptions)
  }, [packageOptions])

  return (<PackageOptionsGrid>
    <PackageSelectionWrapper gap={20}>
      {sortedPackageOptions.map((item) => <LastMinutePackageOption
        key={item.package.uniqueKey}
        offer={offer}
        packageView={item}
      />)}
    </PackageSelectionWrapper>
  </PackageOptionsGrid>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  offer: state.offer,
  packageOptions: getDurationPackageOptions(state, appState),
}), LastMinutePackageOptions)
